// MySVGIcon.js
import React from 'react';

const BreakOp = ({ fillColor = "#070A0E" }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="29" height="29" rx="7.5" fill="#DFE6FF" />

    <g transform="scale(0.05, 0.05) translate(40, 40)">
      <path
        d="m502.625,121.375l-112-112c-6-6-14.141-9.375-22.625-9.375h-224c-8.484,0-16.625,3.375-22.625,9.375l-112,112c-6,6-9.375,14.141-9.375,22.625v224c0,8.484 3.375,16.625 9.375,22.625l112,112c6,6 14.141,9.375 22.625,9.375h224c8.484,0 16.625-3.375 22.625-9.375l112-112c6-6 9.375-14.141 9.375-22.625v-224c0-8.484-3.375-16.625-9.375-22.625zm-134.625,118.621v112c0,35.348-34.262,64.004-69.609,64.004h-46.555c-30.305,0-58.004-17.121-71.555-44.225l-9.891-19.778-40.824-95.258c-4.027-9.402-0.031-20.313 9.113-24.887 8.91-4.453 22.547-1.406 27.824,7.039l25.497,36.304v-35.199-128c0-8.836 7.164-16 16-16s16,7.164 16,16v120c0,4.418 3.582,8 8,8s8-3.582 8-8v-152c0-8.836 7.164-16 16-16s16,7.164 16,16v152c0,4.418 3.582,8 8,8s8-3.582 8-8v-120c0-8.836 7.164-16 16-16s16,7.164 16,16v128 8c0,4.418 3.582,8 8,8s8-3.582 8-8v-8-80c0-8.836 7.164-16 16-16s16,7.164 16,16v80z"
        fill={fillColor} 
      />
    </g>

    <rect x="0.5" y="0.5" width="29" height="29" rx="7.5" stroke="#DFE6FF" />
  </svg>
);

export default BreakOp;
